module.exports = __webpack_public_path__ + "static/img/logo.1ee69c5d.svg";